import { render, staticRenderFns } from "./Intermediar.vue?vue&type=template&id=6ed3190a&"
import script from "./Intermediar.vue?vue&type=script&lang=js&"
export * from "./Intermediar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports